export const ru = {
    'update_success': 'Успешно обновлено',
    'update_available': 'Доступно обновление',
    'tap_to_update': 'Нажмите, чтобы обновить',
    'update': 'Обновить',
    'new_version_available': 'Доступна новая версия',
    'create_success': 'Успешно создано',
    'remove_success': 'Успешно удалено',
    'get_started': 'Начать',
    'open_dashboard': 'Открыть панель управления',
    'search': 'Поиск',
    'app_search_placeholder': 'Найти..',
    'continue': 'Продолжить',
    'login': 'Войти',
    'logout': 'Выйти',
    'attention': 'Внимание',
    'ok': 'Ок',
    'cancel': 'Отмена',
    'error': 'Ошибка',
    'save': 'Сохранить',
    'add': 'Добавить',
    'yes': 'Да',
    'no': 'Нет',
    'next_btn': 'Далее',
    'back_btn': 'Назад',
    'connect_btn': 'Подключиться',
    'confirm_action': 'Подтвердить',
    'confirm_modal_title': 'Подтверждение',
    'confirm_modal_content': 'Вы уверены?',
    'cancel_btn': 'Отмена',
    'close': 'Закрыть',
    'delete': 'Удалить',
    'unknown': 'Неизвестно',
    'sign_up': 'Зарегистрироваться',
    'email': 'Электронная почта',
    'password': 'Пароль',
    'signup': 'Регистрация',
    'create': 'Создать',
    'edit': 'Редактировать',
    'add_new': 'Добавить новое',
    'deleted_success': 'Удалено успешно',
    'upgrade_btn': 'Обновить',
    'upgrade_plan_btn': 'Обновить план',
    'sign_in_with_google': 'Войти через Google',
    'sign_up_with_google': 'Зарегистрироваться через Google',
    'or': 'или',
    'na': 'Н/Д',
    'all_categories': 'Все категории',
    'no_items_found': 'Элементы не найдены',
    'country': 'Страна',
    'tags': 'Теги',
    'tag': 'Тег',
    'all': 'Все',
    'dashboard': 'Панель управления',
    'last_30d': 'Последние 30 дней',
    'results': 'Результаты',
    'hide_btn': 'Скрыть',
    'updated': 'Обновлено',
    'updated_short': 'Обн.',
    'owner': 'Владелец',
    'success_message': 'Операция успешно завершена',
    'select_country': 'Выбрать страну',
    'view_all': 'Показать все',
    'list': 'Список',
    'plan': 'План',
    'info_updated': 'Информация обновлена',
    'show_more': 'Показать больше',
    'pause': 'Пауза',
    'launch': 'Запуск',
    'please_wait': 'Пожалуйста, подождите..',
    'message': 'Сообщение',
    'message_placeholder': 'Введите ваше сообщение',
    'contact_email': 'Контактный E-mail',
    'welcome': 'Добро пожаловать',
    'welcome_to': 'Добро пожаловать в :name',
    'status': 'Статус',
    'enable_btn': 'Включить',
    'enabled': 'Включено',
    'connection_error': 'Ошибка подключения',
    'generating_exercises_title': 'Подготовка упражнений',
    'generating_exercises_message': 'Мы создаём персональные упражнения для вас. Обычно это занимает несколько секунд. Пожалуйста, попробуйте снова через минуту-другую.',
    'app_motto_hallouminati': 'Всё для сдачи экзамена по культуре Кипра',
    'start_quiz_btn': 'Практиковаться',
    // Daily Practice hub (home) — frames the 3 daily practice modes
    'practice_hub_title': 'Ежедневная практика',
    'practice_hub_count': '3 режима',
    'quick_quiz_title': 'Начать тренировку',
    'quick_quiz_subtitle': 'По всем темам экзамена',
    'officials_card_title': 'Официальные лица',
    'officials_card_subtitle': 'Президент, министры и ключевые чиновники',
    'officials_list_title': 'Государственные деятели',
    // Quiz «Слова» sheet + My words (docs/hallouminati/question-words.md)
    'question_words_button': 'Слова',
    'question_listen': 'Прослушать',
    'question_words_title': 'Слова в вопросе',
    'my_words': 'Мои слова',
    'my_words_learn': 'Учить',
    'my_words_learning': 'Учу',
    'question_words_known': 'знаю',
    // Нажать на слово в вопросе; добавление — Adept (docs/hallouminati/question-words.md §Tap a word)
    'question_words_tap_hint': 'Можно нажать на слово прямо в вопросе',
    'question_words_add': 'Добавить в словарь',
    'question_words_adding': 'Добавляю…',
    'question_words_no_translation': 'Это слово не переводим',
    'question_words_add_limit': 'На сегодня лимит, попробуйте завтра',
    'question_words_add_failed': 'Не получилось, попробуйте ещё раз',
    'question_words_copy': 'Скопировать слово',
    'question_words_copied': 'Скопировано',
    'question_words_missing_upsell': 'Этого слова пока нет в нашем словаре. С Adept его можно добавить: переведём и найдём начальную форму.',
    'question_words_add_with_adept': 'Добавить с Adept',
    'question_words_paywall_title': 'Добавляйте любые слова',
    'question_words_paywall_subtitle': 'С Adept любое слово из вопроса попадёт в словарь: с переводом и начальной формой.',
    'my_words_paywall_title': 'Учите слова из вопросов',
    'my_words_paywall_subtitle': 'С Adept слово попадёт в «Мои слова», и мы будем повторять его, пока оно не запомнится.',
    'my_words_split': 'Учу :learning · Выучено :learned',
    // Страница «Мои слова» (docs/hallouminati/question-words.md §My words)
    'my_words_tab_learning': 'Учу :n',
    'my_words_tab_learned': 'Выучено :n',
    'my_words_tab_all': 'Все :n',
    'my_words_study': 'Учить · :n',
    'my_words_review_all': 'Повторить все',
    'my_words_all_topics': 'Все темы',
    'my_words_in_questions_one': 'в :n вопросе',
    'my_words_in_questions_few': 'в :n вопросах',
    'my_words_in_questions_many': 'в :n вопросах',
    'my_words_today': 'сегодня',
    'my_words_tomorrow': 'завтра',
    'my_words_in_days': 'через :n дн.',
    'my_words_exam_questions': 'В вопросах экзамена: :n',
    'my_words_more_questions_one': 'И ещё :n вопрос',
    'my_words_more_questions_few': 'И ещё :n вопроса',
    'my_words_more_questions_many': 'И ещё :n вопросов',
    'my_words_know': 'Уже знаю',
    'my_words_relearn': 'Учить заново',
    'my_words_remove': 'Убрать из «Мои слова»',
    'my_words_removed': 'убрано',
    'my_words_empty': 'Добавляйте слова кнопкой «Слова» в вопросах',
    'my_words_tab_empty': 'Здесь пока нет слов',
    'my_words_save_failed': 'Не получилось сохранить. Попробуйте ещё раз.',
    // Вкладка «Словарь» Hallouminati — главные слова экзамена (docs/hallouminati/vocab-trainer.md §The tab)
    'vocab_exam_words': 'Главные слова экзамена',
    'vocab_step': 'Этап :n из :total',
    'vocab_coverage_label': 'Знакомо слов из вопросов экзамена',
    'vocab_left_to_learn': 'Осталось выучить',
    'vocab_status_known': 'Знаю',
    'vocab_status_learned': 'Выучено',
    'vocab_status_learning': 'Учу',
    'vocab_status_remaining': 'Новые',
    'vocab_skip_known': 'Пропустить знакомые',
    'vocab_mistake_words': 'Слова из вопросов, где вы ошиблись',
    'vocab_list_tab_new': 'Новые :n',
    'vocab_learned_words': 'Выученные слова',
    'vocab_struggling_words': 'Трудные слова',
    'vocab_sort_prompt': 'Отметьте слова, которых не знаете',
    'vocab_sort_learn': 'Учить: :n',
    'vocab_sort_known': 'Знаю: :n',
    'vocab_sort_done': 'Готово',
    'vocab_sort_more': 'Ещё',
    'vocab_sort_result_known': 'Знаю: :n',
    'vocab_sort_result_learn': 'Учить: :n. Эти слова уже в тренировке.',
    'vocab_sort_empty': 'Все слова из вопросов экзамена уже разобраны',
    'vocab_sort_save_failed': 'Не получилось сохранить. Попробуйте ещё раз.',
    // Карточка лестницы (docs/hallouminati/vocab-trainer.md §The ladder)
    'ladder_context_prompt': 'Что значит выделенное слово?',
    'word_status_new': 'Новое',
    'word_status_learning': 'Учу :n/:total',
    'word_status_learned': 'Выучено',
    'word_status_known': 'Знаю',
    'word_retired_toast': 'больше не покажем',
    'undo': 'Отменить',
    'session_exam_coverage': 'Знакомые слова в вопросах экзамена',
    // Вкладка «Словарь» — раздел «Лексика экзамена» (docs/exam-content/07-vocab-deck.md)
    'exam_vocab_title': 'Лексика экзамена',
    'exam_vocab_subtitle': 'Слова из настоящих экзаменационных вопросов — чтобы понимать вопрос, а не угадывать.',
    'vocab_category_question_words': 'Слова из вопросов',
    'vocab_category_institutions': 'Учреждения и аббревиатуры',
    'vocab_category_politics_law': 'Политика и право',
    'vocab_category_geography': 'География',
    'vocab_category_history_culture': 'История и культура',
    'vocab_category_religion_holidays': 'Религия и праздники',
    'vocab_category_daily_life': 'Повседневная жизнь',
    'officials_progress': 'Выучено :learned из :total',
    'officials_status_new': 'Новое',
    'officials_status_learning': 'Изучается',
    'officials_status_learned': 'Выучено',
    'officials_updated': 'Актуально · октябрь 2026',
    'geo_quiz_card_title': 'Карта Кипра',
    'geo_quiz_card_description': 'Изучайте округа, города, деревни и достопримечательности Кипра на карте.',
    'geo_quiz_card_subtitle': 'Округа, города, деревни и места',
    'geo_quiz_start_btn': 'Начать гео-практику',
    'geo_quiz_progress_total': ':total мест для изучения',
    'geo_quiz_prompt_locate_place': 'Где на карте :place?',
    'geo_quiz_prompt_identify_place': 'Какое место отмечено на карте?',
    'geo_quiz_prompt_area_of_place': 'В каком округе расположен :place?',
    'geo_quiz_prompt_locate_area': 'Какая область на карте — :place?',
    'geo_quiz_prompt_identify_area': 'Какая область выделена?',
    'geo_quiz_no_session_title': 'Гео-упражнения пока недоступны',
    'geo_quiz_no_session_body': 'Загляните позже — новый контент добавляется регулярно.',
    'streak_practice_daily': 'Практикуйтесь каждый день, чтобы ваша серия не сбросилась!',
    'exam_progress_title': 'Ваш прогресс',
    'exam_language_notice': 'Рекомендуем вам проходить тесты на греческом языке. Реальный экзамен будет на греческом, поэтому важно ознакомиться с греческой терминологией.',
    'recent_mistakes_title': 'Последние ошибки',
    'practice': 'Упражнения',
    'grammar': 'Грамматика',
    'practice_hub_subtitle': 'Тренируйте четыре навыка для экзамена',
    'practice_readiness_blurb': 'Следите за прогрессом по всем четырём навыкам',
    'practice_start_cta': 'Начать',
    'practice_unlock_soon': 'Скоро откроется',
    'readiness_tier_begin': 'Выберите навык ниже и начните первую тренировку.',
    'readiness_tier_start': 'Хорошее начало — не сбавляйте темп! 🔥',
    'readiness_tier_progress': 'Вы делаете реальный прогресс. Так держать!',
    'readiness_tier_half': 'Уже больше половины пути — у вас получается! 💪',
    'readiness_tier_almost': 'Почти готовы к экзамену. Финишный рывок!',
    'readiness_tier_ready': 'Вы готовы к экзамену! 🎉',
    'grammar_hub_subtitle': 'Тренируйте правила и шаблоны',
    'coming_soon': 'Скоро',
    'practice_reading': 'Чтение',
    'practice_reading_desc': 'Читайте короткие тексты и отвечайте на вопросы',
    'practice_listening': 'Аудирование',
    'practice_listening_desc': 'Слушайте носителей языка и проверяйте понимание',
    'practice_speaking': 'Говорение',
    'practice_speaking_desc': 'Описывайте картинки и говорите с ИИ-репетитором вслух',
    'practice_writing': 'Письмо',
    'practice_writing_desc': 'Составляйте предложения и пишите тексты как на экзамене',
    'speaking_subtitle': 'Тренируйте ваше произношение',
    'speaking_pictures_tab': 'Картинки',
    'speaking_dialogues_tab': 'Диалоги',
    // Голосовые диалоги в реальном времени
    'dialogue_hero_title': 'Живой диалог',
    'dialogue_hero_desc': 'Выберите сценарий и поговорите по-гречески вживую с ИИ-собеседником',
    'dialogue_pick_scenario': 'Сценарии',
    'dialogue_no_scenarios': 'Пока нет доступных сценариев',
    'dialogue_load_failed': 'Не удалось загрузить диалоги',
    'dialogue_choose_role': 'Выберите свою роль',
    'dialogue_role_hint': 'Вы будете говорить за своего персонажа — ИИ сыграет другого.',
    'dialogue_role_fixed_hint': 'В этом сценарии роль фиксирована — ИИ играет другую сторону.',
    'dialogue_partner_level': 'Уровень греческого собеседника',
    'dialogue_continue': 'Продолжить',
    'dialogue_pick_role_cta': 'Сначала выберите роль',
    'dialogue_back_to_dialogues': 'К списку диалогов',
    'dialogue_your_role': 'Ваша роль',
    'dialogue_your_task': 'Ваша задача',
    'dialogue_show_translation': 'Показать перевод',
    'dialogue_hide_translation': 'Скрыть перевод',
    'dialogue_tips_phrases': 'Подсказки и фразы',
    'dialogue_prep_title': 'Что нужно знать',
    'dialogue_prep_subtitle': 'Слова, вопросы и пример для подготовки',
    'dialogue_prep_words': 'Полезные слова',
    'dialogue_prep_ask': 'О чём можно спросить',
    'dialogue_prep_example': 'Пример диалога',
    'dialogue_prep_you': 'вы',
    'dialogue_conversation': 'Разговор',
    'dialogue_conversation_hint': 'Здесь появится ваш разговор…',
    'dialogue_start': 'Начать диалог',
    'dialogue_connecting': 'Подключение…',
    'dialogue_connected_listen': 'Слушайте, затем удерживайте кнопку',
    'dialogue_connected_speak_first': 'Удерживайте кнопку, чтобы начать говорить',
    'dialogue_hold_to_talk': 'Удерживайте',
    'dialogue_recording': 'Запись — отпустите, чтобы отправить',
    'dialogue_recording_short': 'Запись…',
    'dialogue_hold_too_short': 'Удерживайте кнопку, пока говорите',
    'dialogue_finish': 'Завершить',
    'dialogue_finished': 'Диалог завершён',
    'dialogue_mic_denied': 'Для голосовых диалогов нужен доступ к микрофону',
    'dialogue_connect_failed': 'Не удалось подключиться. Попробуйте снова.',
    'dialogue_retry': 'Повторить подключение',
    'dialogue_back': 'Назад',
    'dialogue_locked_title': 'Продолжайте общение с GreekBrain Pro',
    'dialogue_locked_body': 'Вы использовали все бесплатные AI-попытки. Оформите подписку, чтобы продолжать живые голосовые диалоги.',
    'dialogue_quota_title': 'Вы использовали все голосовые диалоги в этом месяце',
    'dialogue_quota_body': 'Лимит обновится в начале следующего месяца. Оформите подписку, чтобы практиковаться без ограничений.',
    'dialogue_activate_pro': 'Активировать GreekBrain Pro',
    'dialogue_all_free': 'Всё остальное — картинки, словарь и упражнения — остаётся бесплатным.',
    'dialogue_evaluation': 'Оценка',
    'dialogue_evaluation_soon': 'Оценка вашего диалога ИИ скоро появится.',
    'dialogue_evaluation_pending': 'Оцениваем ваш диалог… это займёт около полминуты.',
    'dialogue_evaluation_unavailable': 'Эта сессия не была оценена.',
    'dialogue_mode_exam_tag': 'Режим экзамена',
    'dialogue_crit_tasks': 'Задачи выполнены',
    'dialogue_crit_interaction': 'Взаимодействие',
    'dialogue_crit_language': 'Язык',
    'dialogue_crit_register': 'Регистр',
    'dialogue_crit_relevance': 'Отвечает на вопрос',
    'dialogue_crit_grammar': 'Грамматика',
    'dialogue_crit_vocabulary': 'Словарный запас',
    'dialogue_crit_development': 'Полные предложения',
    'dialogue_band_above': 'Выше A2',
    'dialogue_band_meets': 'Уровень A2',
    'dialogue_band_borderline': 'На грани',
    'dialogue_band_below': 'Ниже A2',
    'dialogue_strengths': 'Что получилось',
    'dialogue_improvements': 'В следующий раз',
    'dialogue_better_turns': 'Скажите лучше',
    'dialogue_no_transcript': 'Для этой сессии расшифровка не сохранена.',
    'dialogue_mode_label': 'Как хотите потренироваться?',
    'dialogue_mode_voice': 'Тренировка с ИИ',
    'dialogue_mode_voice_subtitle': 'Живой диалог голосом',
    'dialogue_mode_chip': 'Собирать фразы',
    'dialogue_mode_chip_subtitle': 'Отвечайте, выбирая слова по шаблону',
    'dialogue_mode_progress': 'Пройдено :trained из :total',
    'dialogue_mode_mastered_hint': 'Все диалоги пройдены без ошибок — самое время перейти к живому голосу с ИИ.',
    'dialogue_mode_mastered_badge': 'Освоено',
    'dialogue_mode_recommended_badge': 'Дальше',
    'random_dialogue_title': 'Случайная роль',
    'random_dialogue_subtitle': 'Сценарий и роль выберем мы — как на настоящем экзамене',
    'random_picture_title': 'Случайная картинка',
    'random_picture_subtitle': 'Картинку выберем мы — как на настоящем экзамене',
    'random_sheet_title_dialogue': 'Случайный диалог',
    'random_sheet_title_picture': 'Случайная картинка',
    'random_sheet_subtitle': 'Случайная тема — как на настоящем экзамене',
    'random_start_cta': 'Начать практику',
    'dialogue_pick_mode_cta': 'Выберите способ практики',
    'dialogue_chip_loading': 'Загружаем диалог…',
    'dialogue_chip_no_conversations': 'У этого сценария пока нет готовых диалогов.',
    'dialogue_chip_translate_prompt': 'Ответьте по-гречески:',
    'dialogue_chip_send': 'Отправить',
    'dialogue_chip_replay': 'Прослушать',
    'dialogue_chip_show_translation': 'Перевод',
    'dialogue_chip_reveal_answer': 'Показать ответ',
    'dialogue_chip_correct_answer': 'Правильный ответ',
    'dialogue_chip_continue': 'Дальше',
    'dialogue_chip_summary_title': 'Диалог завершён',
    'dialogue_chip_summary_subtitle': 'Отлично! Попробуйте другой диалог, чтобы закрепить.',
    'dialogue_chip_stat_turns': 'Реплик произнесено',
    'dialogue_chip_stat_errors': 'Ошибок',
    'dialogue_chip_practice_again': 'Тренироваться ещё',
    'dialogue_chip_back_to_all': 'Ко всем диалогам',
    'picture_mode_label': 'Как хотите потренироваться?',
    'picture_mode_voice': 'Говорить и получить оценку',
    'picture_mode_voice_subtitle': 'ИИ расшифрует речь и оценит ваш греческий',
    'picture_mode_chip': 'Собирать предложения',
    'picture_mode_chip_subtitle': 'Нажимайте на греческие слова, чтобы построить описание',
    'picture_mode_progress': 'Пройдено :trained из :total',
    'picture_mode_mastered_hint': 'Все картинки пройдены без ошибок — самое время перейти к живой оценке от ИИ.',
    'picture_mode_mastered_badge': 'Освоено',
    'picture_mode_recommended_badge': 'Дальше',
    'picture_pick_mode_cta': 'Выберите способ практики',
    'picture_chip_start': 'Начать практику',
    'picture_chip_loading': 'Загружаем описание…',
    'picture_chip_translate_prompt': 'Скажите по-гречески:',
    'picture_chip_no_translation': 'Для этого предложения пока нет перевода — попробуйте собрать греческий из фишек ниже.',
    'picture_chip_summary_title': 'Описание готово',
    'picture_chip_summary_subtitle': 'Отлично! Попробуйте ещё раз, чтобы закрепить.',
    'picture_chip_stat_sentences': 'Предложений собрано',
    'picture_chip_stat_errors': 'Ошибок',
    'picture_chip_practice_again': 'Тренироваться ещё',
    'picture_chip_back_to_all': 'Ко всем картинкам',
    'writing_subtitle': 'Подготовка к письменной части КЕГ A2 — собирайте экзаменационные письма из готового набора фраз.',
    'writing_readiness_blurb': 'Освойте набор из 130 фраз — затем подтвердите это полноценным письмом.',
    'writing_curriculum_load_failed': 'Не удалось загрузить программу письма.',
    'writing_no_units': 'Юниты письма ещё не настроены.',
    'writing_unit_complete': 'Завершён',
    'writing_unit_locked': 'Заблокирован — закончите предыдущий юнит',
    'writing_unit_locked_toast': 'Закончите предыдущий юнит, чтобы открыть этот.',
    'writing_phrases_short': 'фраз',
    'writing_phrases_typed': 'набрано',
    'writing_unit_anatomy_subtitle': 'Изучите структуру',
    'writing_anatomy_tag': 'Анатомия',
    'writing_phase_anatomy': 'Анатомия',
    'writing_phase_shared_core': 'Общее ядро',
    'writing_phase_informal_shell': 'Неформальная оболочка',
    'writing_phase_slot_fill_informal': 'Слоты — неформальное',
    'writing_phase_official_shell': 'Официальная оболочка',
    'writing_phase_slot_fill_official': 'Слоты — официальное',
    'writing_phase_anatomy_intro': 'Прежде чем тренировать фразы — посмотрите на два скелета писем, которые предстоит собрать.',
    'writing_phase_shared_core_intro': 'Эти слоты — где, когда, что, стоимость, длительность — нужны в любом письме. Осваиваем один раз.',
    'writing_phase_informal_shell_intro': 'Слоты неформального письма: приветствие, новости, событие, реакция, приглашение, прощание.',
    'writing_phase_slot_fill_informal_intro': 'Смешиваем неформальные слоты, пока полное письмо не пойдёт без остановок.',
    'writing_phase_official_shell_intro': 'Слоты объявления: шапка, заголовок, открытие, что, где, когда, стоимость, длительность, призыв, подпись.',
    'writing_phase_slot_fill_official_intro': 'Смешиваем официальные слоты в полноценные экзаменационные объявления.',
    'writing_tab_curriculum': 'Программа',
    'writing_tab_phrases': 'Фразы',
    'writing_tab_composition': 'Сочинение',
    'writing_phrases_title': 'Тренировка фраз',
    'writing_phrases_mastered_label': 'Освоено',
    'writing_phrases_per_session': 'За сессию',
    'writing_phrases_start_drill': 'Начать тренировку',
    'writing_phrases_empty_title': 'Фразы ещё не отмечены',
    'writing_phrases_empty_blurb': 'Попросите администратора отметить фразы для тренировки набором.',
    'writing_phrases_filter_all': 'Все',
    'writing_phrases_filter_new': 'Новые',
    'writing_phrases_filter_learning': 'Изучаю',
    'writing_phrases_filter_mastered': 'Освоено',
    'writing_phrases_section_practice_next': 'Сначала повторить',
    'writing_phrases_section_practice_next_hint': 'Слабые фразы — тренировка начнёт с них.',
    'writing_phrases_section_new': 'Свежие фразы',
    'writing_phrases_section_new_hint': 'Ещё не встречались — сначала самые короткие.',
    'writing_typing_pool_empty_toast': 'Фразы для тренировки набором пока не отмечены.',
    'writing_typing_instruction': 'Переведите на греческий',
    'writing_typing_hint_label': 'Подсказка',
    'writing_typing_show_hint_btn': 'Показать ответ',
    'writing_typing_hint_disclaimer': 'Напечатайте для тренировки — но это не зачтётся как правильный ответ.',
    'writing_typing_hint_used': 'Вы воспользовались подсказкой — это слово пока не зачтётся как выученное.',
    'writing_anatomy_title': 'Анатомия письма',
    'writing_anatomy_subtitle': 'Две структуры покрывают все задания КГП A2.',
    'writing_anatomy_intro': 'Экзамен требует два письма: неформальное другу и официальное объявление. Каждое строится по фиксированной последовательности слотов — заполняйте их по порядку и получите проходной ответ.',
    'writing_anatomy_load_failed': 'Не удалось загрузить анатомию.',
    'writing_anatomy_complete_cta': 'Понятно — отметить пройденным',
    'writing_anatomy_complete_failed': 'Не удалось сохранить прогресс — попробуйте ещё раз.',
    'writing_anatomy_informal': 'Неформальное письмо (другу)',
    'writing_anatomy_official': 'Официальное объявление / формальное письмо',
    'writing_composition_title': 'Свободное сочинение',
    'writing_composition_subtitle': 'Напишите полное письмо и получите мгновенный ИИ-фидбек по рубрике КГП A2.',
    'writing_composition_locked_title': 'Свободное сочинение заблокировано',
    'writing_composition_locked_blurb': 'Завершите юниты slot-fill (неформальное) в программе, чтобы открыть свободное сочинение.',
    'writing_prompts_load_failed': 'Не удалось загрузить задания.',
    'writing_no_prompts': 'Задания для сочинений ещё не настроены.',
    'writing_available_prompts': 'Доступные задания',
    'writing_history_title': 'Предыдущие отправки',
    'writing_history_empty': 'Пока нет отправок — выберите задание выше, чтобы начать.',
    'writing_letter_informal': 'Неформальное',
    'writing_letter_official': 'Официальное',
    'writing_words_short': 'слов',
    'writing_required_points': 'Обязательные пункты',
    'writing_textarea_placeholder': 'Γράψτε εδώ… (напишите своё письмо по-гречески)',
    'writing_too_short': 'Меньше нормы — продолжайте.',
    'writing_too_long': 'Больше нормы — немного сократите.',
    'writing_submit_failed': 'Не удалось проверить отправку. Ваш текст сохранён — попробуйте ещё раз.',
    'writing_submit': 'Отправить на проверку',
    'writing_grading': 'Проверяем…',
    'writing_prompt_not_found': 'Задание не найдено.',
    'writing_result_title': 'Ваш результат',
    'writing_result_load_failed': 'Не удалось загрузить отправку.',
    'writing_grade_pending': 'Проверка не завершилась',
    'writing_grade_pending_blurb': 'Ваш текст сохранён. Попробуйте отправить ещё раз со страницы сочинения.',
    'writing_kgp_score': 'Балл КГП A2',
    'writing_pass': 'Пройдено — на проходном уровне A2 или выше.',
    'writing_fail': 'Не пройдено — смотрите советы ниже.',
    'writing_rubric_title': 'Разбор по рубрике',
    'writing_rubric_register': 'Регистр соответствует типу письма',
    'writing_rubric_greeting': 'Приветствие присутствует',
    'writing_rubric_closing': 'Закрытие присутствует',
    'writing_rubric_required_prefix': 'Требуется:',
    'writing_your_text': 'Ваш текст',
    'writing_legend_matched': 'из набора',
    'writing_legend_error': 'ошибочный фрагмент',
    'writing_errors_title': 'Ошибки',
    'writing_accent_errors': 'Ударения / орфография',
    'writing_suggestions_title': 'Фразы, которые вы знаете, но не использовали',
    'writing_matched_title': 'Из вашего набора',
    'writing_matched_count': 'выученная фраза(ы) подтверждена в контексте.',
    'writing_try_another': 'Попробовать другое задание',
    'picture_describe_title': 'Опишите картинку',
    'picture_describe_desc': 'Запишите своё описание сцены по-гречески — мгновенная обратная связь',
    'picture_describe_prompt': 'Опишите, что видите',
    'picture_suggested_vocab': 'Попробуйте использовать',
    'picture_record_press_to_start': 'Нажмите на микрофон и опишите картинку по-гречески.',
    'picture_recording_in_progress': 'Идёт запись… нажмите, чтобы остановить.',
    'picture_processing': 'Распознаём ваш греческий и оцениваем…',
    'picture_magic_title': 'Просто говорите — остальное сделает ИИ',
    'picture_magic_subtitle': 'Нажмите кнопку ниже и опишите картинку по-гречески — как на настоящем экзамене. ИИ распознает речь и оценит её по экзаменационным критериям.',
    'picture_tap_to_speak': 'Нажмите и говорите',
    'picture_tap_to_speak_sub': 'ИИ распознает и оценит ваш греческий',
    'picture_recording_finish_hint': 'Завершить',
    'picture_too_short': 'Запись слишком короткая. Попробуйте сказать чуть больше.',
    'picture_record_again': 'Записать снова',
    'picture_record_again_short': 'Заново',
    'picture_next_short': 'Дальше',
    'picture_back_to_pictures': 'К картинкам',
    'picture_show_hints': 'Показать подсказки',
    'picture_hide_hints': 'Скрыть подсказки',
    'picture_hint_questions_label': 'Подумайте',
    'picture_personal_question_label': 'Расскажите о себе',
    'picture_personal_answer_example_label': 'Как рассказать о себе',
    'picture_description_label': 'Пример описания (по-гречески)',
    'picture_level_basic': 'Простой',
    'picture_level_standard': 'Стандартный',
    'picture_level_advanced': 'Продвинутый',
    'picture_hint_vocab_label': 'Полезные слова на греческом',
    'picture_practice_vocab_button': 'Учить слова из этой картинки',
    'picture_vocab_title': 'Словарь к картинкам',
    'picture_vocab_subtitle': 'Слова, которые встречаются в большинстве заданий ΚΕΓ A2',
    'picture_vocab_practice_all': 'Учить все слова',
    'picture_vocab_view_all': 'Показать слова',
    'picture_vocab_load_error': 'Не удалось загрузить словарь',
    'picture_vocab_coming_soon': 'Словарь скоро появится',
    // Shared vocabulary-list component
    'vocab_filter_all': 'Все',
    'vocab_state_new': 'Новые',
    'vocab_state_learning': 'Изучаю',
    'vocab_state_mastered': 'Выучено',
    'vocab_showing': 'Показано',
    'vocab_of': 'из',
    'prev_page': 'Предыдущая страница',
    'next_page': 'Следующая страница',
    'dialogue_practice_vocab_button': 'Учить слова из этого диалога',
    'dialogue_vocab_title': 'Словарь к диалогам',
    'dialogue_vocab_subtitle': 'Слова, которые нужны для большинства разговоров на греческом',
    'dialogue_vocab_practice_all': 'Учить эти слова',
    'dialogue_vocab_view_all': 'Список слов',
    'dialogue_vocab_load_error': 'Не удалось загрузить словарь',
    'dialogue_vocab_coming_soon': 'Словарь скоро появится',
    'picture_strengths': 'Сильные стороны',
    'picture_problems': 'Проблемы',
    'picture_improve': 'Над чем поработать',
    'picture_model_answer': 'Пример ответа',
    'picture_next_picture': 'Следующая картинка',
    'picture_grade_failed': 'Не удалось оценить ваш ответ. Попробуйте ещё раз.',
    // Out-of-usage upsell shown when the learner taps record without AI credits.
    'picture_locked_title': 'Получайте оценку ИИ с GreekBrain Pro',
    'picture_locked_body': 'Вы использовали бесплатные AI-попытки. Активируйте Pro, чтобы и дальше получать мгновенную обратную связь по вашим описаниям.',
    'picture_quota_title': 'Вы использовали все описания картинок в этом месяце',
    'picture_quota_body': 'Лимит обновится в начале следующего месяца. Оформите подписку, чтобы получать оценку ИИ без ограничений.',
    'picture_activate_pro': 'Активировать GreekBrain Pro',
    'picture_gate_try_chip': 'Составить из слов',
    'picture_gate_chip_free': 'Составление предложений из слов остаётся бесплатным.',
    'picture_load_failed': 'Не удалось загрузить картинки',
    'picture_status_not_attempted': 'Ещё нет',
    'picture_insufficient_evidence': 'Недостаточно для оценки',
    'picture_no_speech': '(речь не распознана)',
    'picture_transcript_label': 'Ваше описание',
    'picture_total_score_label': 'Итоговый балл',
    'picture_band_below_a2': 'Ниже A2',
    'picture_band_a2_borderline': 'На грани A2',
    'picture_band_a2_meets_target': 'Уровень A2',
    'picture_band_above_a2': 'Выше A2',
    'picture_criterion_grammar': 'Грамматика',
    'picture_criterion_pragmatic': 'Прагматика',
    'picture_criterion_pronunciation': 'Произношение',
    'picture_criterion_vocabulary': 'Лексика',
    'picture_criterion_communicative': 'Коммуникация',
    'picture_mic_unsupported': 'Запись звука не поддерживается в этой среде.',
    'mic_permission_denied': 'Доступ к микрофону запрещён',
    'greek': 'Греческий',
    'russian': 'Русский',
    'questions_mastered': 'Вопросов выучено',
    'mastery_greek_only_title': 'Засчитывается греческий',
    'mastery_greek_only_desc': 'Вопрос считается выученным, когда вы правильно отвечаете на него на греческом — языке настоящего экзамена. Английский и русский отлично помогают учиться, но этот счётчик растёт только от ответов на греческом.',
    'readiness_formula_note': 'Считаем выученные основные вопросы, с весом каждой темы в настоящем экзамене. Для гражданства нужно 60%, для ПМЖ — 50%.',
    'readiness_how_lead': 'Это прогноз вашего результата на экзамене.',
    'readiness_extra_note': 'Сложные и редкие — усложнённые версии вопросов («что неверно», «дополните фразу») и редкие факты. Они открываются после основных и идут сверх прогноза. Нажмите на «Сложные и редкие», чтобы потренировать только их.',
    'topic_extra_note': 'Сложные и редкие — усложнённые версии вопросов («что неверно», «дополните фразу») и редкие факты. Они открываются после основных и в процент не входят. Нажмите на «Сложные и редкие», чтобы потренировать только их.',
    'topic_how_title': 'Прогресс по теме',
    'topic_how_lead': 'Процент — доля основных вопросов темы, которые вы выучили.',
    'readiness_core_label': 'Основные',
    'readiness_extra_label': 'Сложные и редкие',
    'qstatus_new': 'Новый',
    'qstatus_learning': 'Учу',
    'qstatus_review': 'Повтор',
    'qstatus_mastered': 'Выучено',
    'qstatus_new_desc': 'Этот вопрос вы ещё не практиковали — попробуйте!',
    'qstatus_learning_desc': 'Вы пока разбираетесь с этим вопросом. Продолжайте! 💪',
    'qstatus_review_desc': 'Вы уже отвечали на него верно. Ответьте правильно на греческом 🇬🇷, чтобы выучить его к экзамену.',
    'qstatus_mastered_desc': 'Вы ответили верно на греческом 🇬🇷 — выучено! 🎉',
    'qstatus_practised': 'Практиковали :count×',
    'qstatus_last_seen_today': 'последний раз сегодня',
    'qstatus_last_seen_days': 'последний раз :days дн. назад',
    'avg_accuracy': 'Средняя точность',
    'lang_distibution_title': 'Распределение по языку',
    'correct_answer': 'Правильный ответ',
    'your_answer': 'Ваш ответ',
    'question': 'Вопрос',
    'of': 'из',
    'correct': 'правильно',
    'report_issue': 'Сообщить о проблеме',
    'try_again_btn': 'Ещё раз',
    'back_home': 'Домой',
    'practise_mistakes_btn': 'Повторить ошибки',
    'perfect_session': 'Идеальная тренировка!',
    'session_summary_sub': 'Вы делаете большие успехи!',
    'excellent_work': 'Отличная работа!',
    'excellent_work_sub': 'У вас потрясающий результат!',
    'good_job': 'Хорошо!',
    'good_job_sub': 'Продолжайте в том же духе!',
    'needs_improvement': 'Продолжайте практиковаться!',
    'needs_improvement_sub': 'Практика ведет к совершенству.',
    'keep_trying': 'Не сдавайтесь!',
    'keep_trying_sub': 'Каждая ошибка — это возможность научиться.',
    'perfect_score': 'Идеальный результат!',
    'out_of': 'из',
    'you_got': 'У вас',
    'questions_correct': 'ответов правильных!',
    'cyprus_expert': 'Потрясающе! Вы эксперт по Кипру!',
    'great_job': 'Отличная работа! Вы хорошо знаете Кипр!',
    'good_effort': 'Хорошая попытка! Продолжайте изучать Кипр!',
    'keep_practice': 'Продолжайте практиковаться, чтобы узнать больше о Кипре!',
    'result_above_pass': 'Проходной балл на экзамене — 60%. Вы выше на :n%.',
    'result_below_pass': 'На экзамене нужно 60% — вам не хватило :n%.',
    'result_correct_of': ':score из :total правильных ответов',
    'day_streak_title': 'дней в ударе!',
    'report_success_message': 'Спасибо за сообщение об этом вопросе. Наша команда его рассмотрит.',
    'time_lbl': 'Время',
    'answered_lbl': 'Отвечено',
    'result_time_meta': ':time всего · :per с на вопрос',
    'result_time_meta_exam': ':time из :limit · :per с на вопрос',
    'show_translation': 'Показать перевод',
    'hide_translation': 'Скрыть перевод',
    'tap_words_below': 'Выбирайте слова ниже',
    'vocabulary': 'Словарь',
    'handbook': 'О Кипре',
    'exams': 'Экзамены',
    'exams_mock_title': 'Пробный тест',
    'exams_mock_body': '25 вопросов по всем темам за 45 минут — как на настоящем экзамене. Чтобы сдать, нужно 60%.',
    'exams_mock_start': 'Начать пробный тест',
    'exams_ai_title': 'AI-экзамен',
    'exams_ai_subtitle': 'Вопросы уровня июля 2026, обновлено в октябре',
    'exam_new_badge': 'новый',
    'official_passed': 'Сдан',
    'official_not_passed': 'Не сдан, нужно 60%',
    'official_passed_count': 'сдано :passed из :total',
    'home': 'Главная',
    'coming_soon_title': 'Скоро всё будет!',
    'essential_words': 'Основные Слова и Фразы',
    'vocabulary_description_hallouminati': 'Выучите ключевые слова и выражения, которые чаще всего встречаются в тесте по культуре Кипра.',
    'vocabulary_description_greekbrain': 'Учите только те слова, которые нужны для официального экзамена ΚΕΓ (уровень A2)',
    'ai_exam_title': 'Экзамен на основе AI',
    'ai_exam_description': 'Проверьте себя с помощью теста, созданного AI, полностью адаптированного к формату официального экзамена по культуре Кипра.',
    'ai_exam_button': 'Начать AI Практику',
    'real_exam_button': 'Пройти пробный экзамен',
    'real_exam_title': 'Пробный экзамен',
    'real_exam_description': 'Тренируйтесь в точном соответствии с форматом и временем проведения реального экзамена по культуре Кипра. 25 вопросов в условиях экзамена.',
    'official_exams_title': 'Официальные экзамены',
    'official_exams_description': 'Пройдите официальные экзамены прошлых лет. Идеально подходит для понимания моделей вопросов и уровней сложности.',
    'questions_num': ':num вопросов',
    'exam_coming_soon': 'Скоро будет доступен',
    'exam_discuss_tg': 'Обсуждение экзамена в нашей группе',
    'july2026_banner_title': 'Экзамены июля 2026',
    'july2026_banner_subtitle': 'Оба варианта с экзамена 4 июля уже доступны.',
    'july2026_banner_variant1': 'Вариант I',
    'july2026_banner_variant2': 'Вариант II',
    'soon': 'скоро',
    'practice_session': 'Тренировка',
    'my_progress': 'Мой прогресс',
    'word': 'Слово',
    'show_answer': 'Показать ответ',
    'dont_know': 'Не знаю',
    'mark_learned': 'Отметить выученным',
    'mark_learned_sheet_desc': 'Отметить выученным и убрать из повторений',
    'words_learned': 'Выучено слов',
    'meaning': 'Значение',
    'daily_goal': 'Цель на день',
    'daily_streak': 'Ежедневная серия',
    'days_in_row': 'дней подряд',
    'today': 'Сегодня',
    'words_practiced': 'слов изучено',
    'accuracy': 'Точность',
    'correct_answers': 'Правильные ответы',
    'mistakes': 'Ошибки',
    'recent_words': 'Недавно выученные',
    'keep_learning': 'Изучайте новые слова каждый день',
    'start_practice': 'Начать тренировку',
    'speed': 'Скорость',
    'speed_steady': 'Спокойно',
    'speed_focused': 'Внимательно',
    'speed_blazing': 'Молниеносно',
    'speed_speedy': 'Быстро',
    'practice_more': 'Тренироваться ещё',
    'back_to_dashboard': 'Вернуться домой',
    'progress': 'Прогресс',
    'skill_progress': 'Прогресс навыков',
    'nowordslearned_placeholder': 'Еще нет выученных слов. Продолжайте практиковаться!',
    'have_question_btn': 'Есть вопросы по приложению?',
    'what_is_the_issue': 'В чем проблема с этим вопросом?',
    'additional_details': 'Дополнительные детали',
    'additional_details_placeholder': 'Пожалуйста, предоставьте любую дополнительную информацию, которая может помочь нам понять проблему...',
    'submit_report': 'Отправить отчет',
    'report_reason_wrong_translation': 'Неправильный перевод',
    'report_reason_misleading': 'Вопрос вводит в заблуждение',
    'report_reason_incorrect_answer': 'Неправильный ответ отмечен как правильный',
    'report_reason_unclear_options': 'Ответы неясны',
    'report_reason_duplicate': 'Повторяющийся вопрос',
    'report_reason_other': 'Другая проблема',
    'report_comment_min_length': 'Пожалуйста, введите не менее 10 символов',
    'report_error_message': 'Не удалось отправить отчет. Попробуйте еще раз.',
    'report_reason_required': 'Пожалуйста, выберите причину',
    // Practice report reasons (for grammar, comprehension exercises)
    'practice_report_reason_wrong_answer': 'Правильный ответ неверен',
    'practice_report_reason_confusing_question': 'Вопрос запутанный',
    'practice_report_reason_unclear_options': 'Варианты ответов неясны',
    'practice_report_reason_wrong_explanation': 'Объяснение неверное',
    'practice_report_reason_other': 'Другая проблема',
    // Vocab report reasons (for vocabulary review exercises)
    'practice_report_reason_wrong_translation': 'Перевод неверен',
    'practice_report_reason_incorrect_pronunciation': 'Произношение неверное',
    'practice_report_reason_wrong_word_class': 'Часть речи неверна',
    'practice_report_reason_missing_meaning': 'Отсутствует значение/определение',
    'practice_report_reason_wrong_example': 'Пример предложения неверен',
    // Geo report reasons (for Cyprus geography quiz places)
    'practice_report_reason_wrong_location': 'Место расположено неправильно',
    'practice_report_reason_wrong_name': 'Название места неверное',
    'practice_report_reason_wrong_description': 'Описание неверное',
    'practice_report_reason_missing_description': 'Описание отсутствует',
    // Picture-speaking AI evaluation report reasons (beta)
    'practice_report_reason_speech_not_recognized': 'Моя речь распознана неправильно',
    'practice_report_reason_score_unfair': 'Оценка кажется несправедливой',
    'practice_report_reason_wrong_feedback': 'Замечания или исправления неверны',
    'practice_report_reason_bad_example_answer': 'Пример ответа неверный или неестественный',
    'practice_report_reason_technical_problem': 'Что-то не сработало (техническая проблема)',
    'picture_report_evaluation_issue': 'Сообщить о проблеме с этой оценкой',
    'total_questions': 'Всего вопросов',
    'exam_readiness': 'Готовность к экзамену',
    'try_greek': 'Попробуй греческий!',
    'questions_attempted': 'Попыток',
    'practice_topic': 'Практиковать тему',
    'quick_practice': 'Быстрая практика',
    'topic_practice_all': 'Все :count',
    'topic_learned_of': ':learned из :total выучено',
    'topic_mastery': 'Ваш уровень знания тем',
    'show_less': 'Скрыть',
    'match_pairs_hint': 'Выберите совпадающую пару',
    'choose_correct_translation': 'Выберите правильный перевод',
    'awesome': 'Отлично',
    'incorrect': 'Неправильно',
    'got_it': 'Понятно',
    'correct_answer_is': 'Правильный ответ',
    'show_hint': 'Показать пояснение',
    'check_btn': 'Проверить',
    'words_struggling_with': 'Слова, которые вызывают трудности',
    'no_struggling_words': 'Нет слов, с которыми у вас сейчас трудности',
    'recently_mastered': 'Недавно выученные',
    'no_mastered_words': 'Пока нет выученных слов',
    'see_all': 'Смотреть все',
    'practice_history': 'История тренировок',
    'no_practice_history': 'Пока нет истории тренировок. Продолжайте учиться!',
    'goal_completed': 'Дневная цель достигнута!',
    'goal_exceeded': 'Цель превышена! Отличная работа!',
    'words_left': 'слов осталось',
    'day_in_row': 'день подряд',
    'motivation_quote': 'Каждое выученное слово – шаг к свободному владению языком',
    'keep_going': 'Так держать!',
    'total': 'всего',
    'words_mastered': 'Слов выучено',
    'practice_these_words': 'Практиковать эти слова',
    'struggling_words_description': 'Сфокусируйтесь на этих словах, чтобы улучшить свой словарный запас. Это слова, где ваша точность ниже 70%.',
    'mastery_progress': 'Прогресс освоения',
    'last_practiced': 'Последняя тренировка',
    'struggling_words_empty_message': 'Отличная работа! Вы хорошо справляетесь со всем словарным запасом.',
    'repetition_quote': 'Повторение - мать учения',
    'practice_consistently': 'Практикуйте эти слова регулярно для лучших результатов!',
    'word_collection': 'Коллекция слов',
    'vocabulary_progress': 'Прогресс',
    'words': 'слов',
    'complete': 'завершено',
    'mastered_words': 'Выучено',
    'learning_words': 'Изучаю',
    'new_words': 'Новые',
    'all_words': 'Все слова',
    'showing': 'Показано',
    'track_your_progress': 'Отслеживайте свой прогресс',
    'no_words_found': 'Слова не найдены',
    'start_practicing_to_see_words': 'Начните тренировку, чтобы увидеть свой словарь здесь',
    'no_words_in_category': 'В этой категории пока нет слов',
    'review_mastered_words': 'Повторить выученные слова',
    'learn_new_words': 'Изучить новые слова',
    'last_practice': 'Последняя практика',
    'yesterday': 'Вчера',
    'ago': 'назад',
    'start_practicing_message': 'Начните тренировку, чтобы добавить слова в свою коллекцию.',
    'all_words_seen': 'Вы просмотрели все доступные слова!',
    'congratulations_all_words': 'Поздравляем! Вы познакомились со всеми словами в нашей базе данных.',
    'tip_review_regularly': 'Совет: Регулярно повторяйте выученные слова, чтобы сохранить их в памяти!',
    'tip_learn_daily': 'Совет: Старайтесь учить по 5-10 новых слов в день для лучших результатов!',
    'profile': 'Профиль',
    'settings': 'Настройки',
    'member_since': 'Участник с',
    // Profile membership card (features/Profile/MembershipCard.tsx)
    'membership_adept_title': 'Адепт Халуминати',
    'membership_adept_since': 'С :date',
    'membership_free_title': 'Бесплатная версия',
    'membership_free_body': 'Адептам доступны все материалы.',
    'membership_free_cta': 'Стать адептом',
    'telegram_user': 'Пользователь Telegram',
    'exam_questions': 'Экзаменационные вопросы',
    'learning_streak': 'Серия обучения',
    'first_day_streak': 'Первый день вашего обучения!',
    'days_streak_message': ':days дней непрерывного обучения!',
    'start_streak_today': 'Начните серию сегодня!',
    'support_us': 'Поддержите нас',
    'support_description': 'Помогите нам сохранить приложение бесплатным и улучшить его новыми функциями!',
    'buy_me_coffee': 'Купить кофе',
    'revolut_support': 'Донат через Revolut',
    'coffee_opens_browser': 'Открывается во внешнем браузере',
    'app_language': 'Язык приложения',
    'quiz_language': 'Язык вопросов',
    'quiz_language_description': 'Симуляция экзамена всегда начинается на греческом',
    'quiz_language_update_failed': 'Не удалось сохранить язык вопросов. Попробуйте ещё раз.',
    'language_description': 'Изменить язык интерфейса',
    'study_reminders': 'Напоминания',
    'reminders_description': 'Получать сообщения с напоминаниями от бота',
    'notifications_blocked_banner': 'Уведомления заблокированы в настройках телефона. Нажмите, чтобы включить.',
    'notifications_denied_error': 'Уведомления заблокированы. Включите их в настройках телефона.',
    'open_settings': 'Открыть настройки',
    'settings_updated': 'Настройки успешно обновлены',
    'haptic_feedback': 'Виброотклик',
    'haptic_feedback_description': 'Вибрация при нажатиях и ответах',
    'autoplay_audio': 'Автоозвучка',
    'appearance': 'Тема',
    'appearance_system': 'Авто',
    'appearance_light': 'Светлая',
    'appearance_dark': 'Тёмная',
    'never': 'Отключены',
    'hourly': 'Раз в час',
    'daily': 'Каждый день',
    'weekly': 'Еженедельно',
    'share_with_friends': 'Поделиться с друзьями',
    'share_description': 'Помогите друзьям тоже подготовиться к экзаменам на Кипре!',
    'share_app': 'Поделиться приложением',
    'share_message': 'Посмотрите на это отличное приложение для подготовки к экзаменам на Кипре! 🇨🇾',
    'help_support': 'Помощь и поддержка',
    'still_need_help': 'Все еще нужна помощь?',
    'contact_support': 'Связаться с поддержкой',
    'rate_us': 'Оцените нас в App Store',
    'rate_us_desc': 'Нравится приложение? Оставьте нам отзыв в AppStore',
    'rate_us_btn': 'Оставить отзыв',
    'app_version': 'Версия',
    'made_with_love': 'Сделано с ❤️ на Кипре',
    'about_exam': 'Об экзамене',
    'about_exam_btn': 'Что за экзамен и как сдать?',
    'memory_check_title': 'Помните ли вы это слово?',
    'memory_check_yes': '✅ Да, помню',
    'memory_check_no': '❌ Нет, забыл',
    'memory_check_success': "🎉 *Отличная память!*\n\n`:word` → :translation\n\n_Продолжайте в том же духе!_",
    'memory_check_forgot': "📚 *Ничего страшного!*\n\nВот значение:\n\n`:word` → :translation\n\n_Мы будем практиковать это слово чаще._",
    'quiz_title': '🎯 *Быстрая викторина*',
    'vocab_quiz_question': "Как сказать *:translation* по-гречески?\n\n_Выберите правильный ответ:_",
    'exam_quiz_question': "Какой правильный ответ?\n\n*:question*\n\n_Выберите правильный ответ:_",
    'quiz_correct': "✅ *Правильно!*\n\n`:answer`\n\n_Отлично! Продолжайте практиковаться._",
    'quiz_incorrect': "❌ *Не совсем верно*\n\nПравильный ответ:\n\n`:answer`\n\n_Попробуйте еще раз!_",
    'practice_button': "📱 Давайте практиковаться",
    'practice_more_button': '🎮 Больше практики',
    'practice_mode_button': '📱 Режим практики',
    'try_another_button': 'Попробовать еще',
    'memory_check_button': '🔄 Еще одна проверка',
    'send_more_vocab': '🔄  Еще слово',
    'send_more_exam': '🔄  Еще вопрос',
    'send_more_any': '🔄  Еще',
    'unsubscribe_button': '🔕 Отключить уведомления',
    'reminder_offer_title': 'Напомнить о тренировке завтра?',
    'reminder_offer_subtitle': 'Одно уведомление в день, в это же время. Отключить можно в профиле.',
    'reminder_turn_on': 'Напоминать',
    'not_now': 'Не сейчас',
    'reminder_enabled_message': 'Уведомления включены. Вы можете изменить их в настройках профиля.',
    'reminder_disabled_message': 'Ничего страшного. Вы можете включить их в своём профиле, если передумаете.',
    'exam_passed': 'Экзамен сдан!',
    'exam_late_fade': 'В последней трети экзамена ошибок заметно больше, чем в первой.',
    'exam_language_warning': 'Часть вопросов вы прошли не на греческом. На экзамене они только на греческом.',
    'review_in_guide_title': 'Что разобрать в гиде',
    'loading': 'Загрузка',
    'did_you_know': 'Знаете ли вы?',
    'means': 'означает',
    'session_load_error': 'Невозможно загрузить тренировочную сессию',
    'session_load_error_default': 'Что-то пошло не так при загрузке тренировочной сессии.',
    'try_again': 'Попробуйте еще раз',
    'retrying': 'Пытаемся',
    'practice_by_level': 'Практика по уровню сложности',
    'practice_by_level_description': 'Выберите уровень для изучения определенных групп слов',
    'level': 'Уровень',
    'practice_by_word_type': 'Практика по типу слов',
    'practice_by_word_type_description': 'Сосредоточьтесь на определенных категориях слов',
    'verbs': 'Глаголы',
    'adjectives': 'Прилагательные',
    'adverbs': 'Наречия',
    'prepositions': 'Предлоги',
    'nouns': 'Существительные',
    'pronouns': 'Местоимения',
    'numerals': 'Числительные',
    'phrases': 'Фразы',
    'practicing': 'Практикуем',
    'filtered_by_word_class': 'Показаны только слова из этой категории',
    'chapter_not_found': 'Глава не найдена',
    'guide_title_part1': 'Основы Кипра',
    'guide_title_part2': ' от А до Я',
    'app_title_hallouminati': 'Hallouminati Academy',
    'xp_needed': 'Нужно XP',
    'words_learned_today': 'Слов изучено сегодня',
    'learning': 'Изучаю',
    'learned': 'Изучено',
    'mastered': 'Освоено',
    'total_words': 'Всего слов',
    'progress_words': ':current из :target слов',
    'streak': 'Серия',
    'select_frequency': 'Выбрать частоту',
    'notification_prompt_message_1': 'Готовы достичь своих целей сегодня?',
    'notification_prompt_message_2': 'Постоянство – залог успеха! 🗝️ Давайте вместе заниматься каждый день.',
    'notification_prompt_message_3': 'Не дайте своей серии остыть! 🔥 Включите напоминания.',
    'turn_on_notifications': 'ДАВАЙ!',
    'matches': 'пар',
    'good_remember': 'Отлично! Продолжайте в том же духе!',
    'word_graduated_to_review': 'Превосходно! Это слово перешло на этап повторения!',
    'good_start_learning': 'Хорошее начало! Продолжайте практиковаться.',
    'dont_worry_will_practice_more': 'Не волнуйтесь! Мы будем практиковать это слово чаще.',
    'dont_worry_will_return': 'Не волнуйтесь! Это слово вернется для повторения.',
    'correct_match': 'Правильное совпадение!',
    'incorrect_match': 'Не совсем так, попробуйте еще раз.',
    'correct_choice': 'Правильно!',
    'incorrect_choice': 'Неправильно',
    'word_marked_learned': 'Слово отмечено как изученное!',
    'word_reset': 'Слово было сброшено.',
    'logout_confirm': 'Вы уверены, что хотите выйти?',
    'logging_out': 'Выход...',
    'reset_progress': 'Сбросить прогресс',
    'reset_progress_description': 'Очистить все данные обучения и начать заново',
    'reset_progress_title': 'Сбросить весь прогресс?',
    'reset_progress_warning': 'Это навсегда удалит весь ваш прогресс обучения, включая выученные слова, историю практики и серии. Это действие нельзя отменить.',
    'reset_progress_confirm_btn': 'Сбросить всё',
    'resetting_progress': 'Сбрасываем...',
    'reset_progress_success': 'Ваш прогресс успешно сброшен',
    'reset_progress_error': 'Не удалось сбросить прогресс. Попробуйте еще раз.',
    'reset': 'Сбросить',

    'guide_read_progress': 'Прочитано',
    'guide_welcome_title': 'Культура и политика Кипра.\nТолько то, что нужно знать',
    'guide_welcome_subtitle': 'Специально для сдачи экзамена.',
    'guide_welcome_intro_bold': 'Добро пожаловать в гид по Кипру.',
    'guide_welcome_intro_text': 'Ваша цель — сдать экзамен. Мы изучили несколько сотен экзаменационных вопросов за последние годы. Оставили только то, что реально нужно.',
    'guide_welcome_why_different': 'Чем этот гид отличается:',
    'guide_welcome_point1_title': 'Без воды:',
    'guide_welcome_point1_text': 'Никаких длинных лекций. Только факты, даты и имена',
    'guide_welcome_point2_title': 'Логика экзамена:',
    'guide_welcome_point2_text': 'Каждая глава — это темы, которые часто встречаются на реальном экзамене.',
    'guide_welcome_point3_title': 'Всегда актуально:',
    'guide_welcome_point3_text': 'Политика меняется. Мы обновляем гид: новые министры, экономические данные, политические события.',
    'guide_welcome_quote': 'От горы Олимп до последних изменений в правительстве — всё здесь.',
    'guide_welcome_start_button': 'Начать',


    // FAQ Section
    'faq_q1': 'Как работает приложение?',
    'faq_a1': 'Наше приложение помогает подготовиться к экзаменe по культуре Кипра через ежедневные практические занятия. Отвечайте на вопросы и изучайте словарь, чтобы улучшить результаты и поддерживать серию обучения',
    'faq_q2': 'Можно ли выучить всё для экзамена только по приложению?',
    'faq_a2': 'Да, если вы умеете читать по-гречески.<br />Мы советуем заниматься каждый день: сначала отвечать на вопросы на русском, потом постепенно переходить на греческий. Параллельно тренируйте слова в разделе «Словарь» — в комфортном для вас темпе.<br />Ближе к дате экзамена рекомендуем проходить полные тесты на греческом языке в разделе «Экзамены».<br /><br />По последнему опросу (май 2026) наших пользователей, 82% тех, кто готовился с помощью Халуминати, сдали экзамен с первого раза.',
    'faq_q3': 'Сколько времени нужно на подготовку?',
    'faq_a3': 'Мы знаем людей, которые начали с уровня A0 (умели только читать и знали пару слов) — за месяц ежедневных занятий подготовились и успешно сдали экзамен.<br />Всё зависит от вашей мотивации и регулярности.',
    'faq_q4': 'Откуда взяты вопросы? Это официальные материалы?',
    'faq_a4': 'Мы собрали задания из экзаменов прошлых лет, которые были в открытом доступе.<br />Также мы составили собственные вопросы на основе информации с официального туристического портала visitcyprus.com и новостных сайтов вроде cyprus-mail.com.<br />Формулировки могут отличаться от официальных, но темы и уровень совпадают.',
    'faq_q5': 'Почему приложение бесплатное?',
    'faq_a5': 'Мы сделали приложение для себя и друзей, чтобы самим подготовиться к экзамену.<br />А сейчас хотим, чтобы оно помогло как можно большему числу людей сдать экзамен по культуре Кипра.<br /><br />Если же вы хотите поддержать проект, то можно отправить донат в разделе «Поддержка».',
    'faq_q6': 'Кто сделал это приложение?',
    'faq_a6': 'Леонид Жаворонков — <a class="text-link" href="https://t.me/zhavoronkov">t.me/zhavoronkov</a>',
    'faq_q7': 'Как часто вы обновляете вопросы?',
    'faq_a7': 'Новые вопросы мы добавляем сразу после появления официальных экзаменов в открытом доступе — как правило, в день экзамена.<br />Кроме того, за 1–2 месяца до экзамена мы загружаем 30–40 свежих заданий, составленных на основе последних новостей и событий на Кипре.',
    'faq_q12': 'В базе больше 1000 вопросов. Неужели нужно выучить все?',
    'faq_a12': 'Нет. Вопросы идут не вперемешку, а по важности — самое нужное вы увидите первым:<br />1) Сначала — вопросы прошлых экзаменов и ключевые факты.<br />2) Затем — остальные важные темы.<br />3) Редкие факты — только когда вы прошли ~70% основных вопросов темы. В пробном экзамене их не больше 3 из 25.<br /><br />Усложнённые версии («что неверно», «дополните фразу») появляются только после того, как вы правильно ответили на исходный вопрос.<br />Вопросы, в которых вы ошибаетесь, возвращаются чаще, а вопросы прошлых экзаменов повторяются чаще остальных.',
    'faq_q8': 'Как вы выбираете слова для словаря?',
    'faq_a8': 'Мы взяли все слова из базы вопросов и отсортировали их по частоте.<br />На этой основе формируется словарь.<br />Для тренировок используется система SRS (интервальные повторения): она сама решает, какие слова нужно повторять и когда, чтобы вы лучше запоминали.',
    'faq_q11': 'По какому принципу слова помечаются как выученные?',
    'faq_a11': 'Слово не помечается «выученным» по одному правильному ответу — мы используем систему интервальных повторений (SRS). Каждое слово проходит несколько ступеней повторения с растущими промежутками (2 часа → 8 часов → 1 день → 3 дня → 7 дней): правильный ответ продвигает слово вперёд, ошибка — откатывает назад.<br />Статус «выучено» слово получает только когда вы стабильно отвечаете правильно — например, прошли все ступени или показали высокий процент верных ответов (около 80%+) при достаточном числе попыток.<br />Более сложные упражнения (ввод полного перевода) продвигают слово быстрее, чем лёгкие (выбор из вариантов или сопоставление пар). А если вы позже забыли уже выученное слово, оно может вернуться обратно на повторение.',
    'faq_q10': 'Как можно обнулить свой прогресс в приложении?',
    'faq_a10': 'Перейдите на страницу Профиля, прокрутите вниз до раздела Настройки и нажмите кнопку "Сбросить" рядом с "Сбросить прогресс". Это очистит все ваши данные обучения и позволит начать заново.',
    'faq_q99': 'А у вас есть такое же приложение, но для тех, кто готовится к экзамену по языку?',
    'faq_a99': 'Да! Для этого мы сделали мини-приложение GreekBrain — попробуйте здесь: <a href="https://t.me/greekbrain_bot" class="text-link">t.me/greekbrain_bot</a>',

    // Cyprus Guide
    'exam_guide': 'Гид к экзамену',
    'latest_update': 'Последнее обновление',
    'recent_updates': 'Обновления',
    'no_recent_updates': 'Нет недавних обновлений.',
    'loading_guide_content': 'Загружаем содержание гида...',
    'failed_to_load_guide': 'Не удалось загрузить гид',
    'tap_to_retry': 'Нажмите, чтобы повторить',
    'completed': 'Завершено',
    'view_chapter': 'К главе',
    'guide_pdf_download': 'Скачать гид в PDF',
    'guide_pdf_download_free': 'Скачать бесплатную версию в PDF',
    'guide_pdf_preparing': 'Готовим вашу личную копию…',
    'guide_pdf_open': 'Открыть PDF',
    'guide_pdf_failed': 'Не получилось подготовить PDF. Попробуйте позже.',
    'chapters': 'глав',
    'more': 'ещё',
    'pro': 'ADEPT',
    'min_read': 'мин. чтения',
    'chapter': 'Глава',
    'lifetime_access': 'Доступ навсегда',
    'processing': 'Обработка...',
    'loading_chapter': 'Загружаем главу...',
    'no_content_available': 'Нет доступного содержания для этой главы.',
    'chapter_load_failed': 'Не удалось загрузить главу. Возможно, проблема с соединением — попробуйте ещё раз.',
    'chapter_not_downloaded': 'Вы офлайн, а эта глава ещё не загружена. Подключитесь к интернету, чтобы прочитать её.',
    'no_internet_title': 'Нет подключения к интернету',
    'guide_offline_uncached': 'Подключитесь к интернету один раз, чтобы скачать гид — после этого он будет доступен офлайн.',
    'guide_saved_offline': 'Доступно офлайн',
    'guide_saving_offline': 'Сохраняем для офлайн',
    'guide_downloaded_offline': 'загружено для офлайн',
    'guide_offline_ready_desc': 'Все главы загружены — гид можно читать без интернета.',
    'guide_offline_saving_desc': 'Главы загружаются, чтобы вы могли читать гид офлайн.',
    'guide_offline_partial_desc': 'Подключитесь к интернету, чтобы загрузить гид полностью.',
    'chapter_complete': 'Глава завершена!',
    'great_job_mastering': 'Отличная работа! Вы освоили эту тему.',
    'next_chapter': 'Следующая глава',
    'keep_reading': 'Продолжайте читать',

    // Topic Mastery Guide Link
    'study_in_guide': 'Изучить в гиде',

    // Report Issue
    'found_mistake': 'Нашли неточность?',
    'report_issue_description': 'Спасибо, что помогаете стать лучше! Опишите, пожалуйста, ошибку.',
    'report_issue_placeholder': 'например, Дата во втором абзаце указана неверно...',
    'send_report': 'Отправить',
    'sending_report': 'Отправляем...',
    'report_sent_success': 'Спасибо! Мы всё проверим.',
    'report_issue_min_length': 'Пожалуйста, введите не менее 10 символов',

    // Paywall
    'paywall_title_default': 'Став адептом вы получите:',
    'paywall_subtitle_default': 'Всё для подготовки к\u00a0экзамену по культуре',
    'paywall_benefit_1': 'Гид по Кипру: 40+ глав про историю, культуру, финансы и актуальные события острова',
    'paywall_benefit_2': 'База из 1 200+ вопросов',
    'paywall_benefit_3': 'Геовикторина с интерактивной картой',
    'paywall_benefit_4': 'Тренажёр 2 400+ греческих слов из вопросов экзамена',
    'paywall_benefit_5': 'Тренажёр официальных лиц Кипра',
    'paywall_guide_title': 'Весь гид и всё для подготовки к экзамену',
    'paywall_content_updated': 'Обновлено: окт. 2026',
    'paywall_content_updated_short': 'окт. 2026',
    'paywall_social_count': '11 000+',
    'paywall_social_label': 'человек сдали\nэкзамен с нами',
    'paywall_pass_rate': '82%',
    'paywall_pass_rate_label': 'сдают с\nпервого раза',
    'paywall_cta_price': 'Единоразовый платёж',
    'paywall_cta_button': 'Открыть полный доступ',
    'one_time_payment': 'Единоразовый платёж',
    'paywall_guide_context_title': 'Вступайте в Адепты Халуминати',
    'paywall_guide_context_subtitle': 'Эта глава доступна только Адептам Халуминати.',
    'premium_content_locked': 'Премиум контент',
    'unlock_full_chapter': 'Разблокируйте, чтобы продолжить',
    'sign_in': 'Войти',
    'sign_in_required': 'Необходима авторизация',
    'sign_in_to_unlock': 'Войдите, чтобы открыть эту главу',
    'auth_required_message': 'Войдите в свой аккаунт, чтобы получить доступ к экзаменам, тренировкам и всем функциям приложения.',
    'exam_registration_date': 'Регистрация на экзамен откроется 16 декабря',
    'correct_order': 'Правильный порядок',
    'special_offer_onboarding': 'Специальное предложение',
    'special_offer_limited': 'Ограниченное время',
    'offer_expires_in': 'Истекает через:',
    'paywall_no_recurring': 'Единоразовый платеж. Никаких подписок.',
    'paywall_loading': 'Загружаем ваше предложение…',
    'paywall_load_failed': 'Не удалось загрузить цену. Проверьте соединение и попробуйте снова.',
    'paywall_retry': 'Повторить',
    'purchase_success': 'Покупка прошла успешно! Добро пожаловать в Адепты Халуминати.',
    'purchase_failed': 'Покупка не удалась. Попробуйте ещё раз.',
    'restore_purchases': 'Восстановить покупки',
    'purchases_restored': 'Ваша покупка была восстановлена!',
    'restore_failed': 'Не найдено покупок для восстановления.',
    'terms_of_use': 'Условия использования',
    'privacy_policy': 'Политика конфиденциальности',

    // Payment success / Adept welcome screen
    'payment_processing_title': 'Обрабатываем платёж…',
    'payment_processing_subtitle': 'Подтверждаем ваш статус Адепта, секундочку…',
    'payment_processing_attempt': 'Попытка :current из :max',
    'adept_welcome_title': 'Теперь вы — Адепт Халуминати!',
    'adept_welcome_subtitle': 'Поздравляем — пожизненный доступ к полному гиду, всем вопросам и экзаменационной лексике — ваш.',

    // Refer-a-friend discount
    'referral_paywall_perk_title': 'Приведите друга',
    'referral_paywall_perk_text': 'После покупки вы получите код на скидку :percent% для друга — он действует :days дня.',
    'referral_have_code': 'Есть код на скидку?',
    'referral_apply': 'Применить',
    'referral_code_applied_title': 'Скидка :percent% применена',
    'referral_code_remove': 'Убрать',
    'referral_code_invalid': 'Этот код недействителен или истёк.',
    'referral_code_unavailable': 'Коды на скидку временно недоступны. Попробуйте позже.',
    'referral_discount_applied': 'Скидка для друга',
    'referral_banner_title': 'Подарите другу скидку :percent%',
    'referral_banner_info_title': 'Как другу получить скидку',
    'referral_banner_info_text': 'Перед оплатой пусть нажмёт «Есть код на скидку?» над кнопкой «Открыть полный доступ» и введёт ваш код — цена сразу станет на :percent% ниже.',
    'referral_banner_info_reuse': 'Код подойдёт нескольким друзьям, пока не истёк.',
    'referral_copy': 'Копировать',
    'referral_share': 'Поделиться',
    'referral_code_copied': 'Код скопирован!',
    'referral_expires_in': 'Истекает через :time',
    'referral_ticket_title': 'Подарите другу',
    'referral_time_left': 'Осталось :time',
    'duration_days_hours': ':days д :hours ч',
    'duration_hours_minutes': ':hours ч :minutes мин',
    'duration_minutes': ':minutes мин',
    'referral_share_text': 'Скидка :percent% на Халуминати — приложение для подготовки к экзамену по истории и культуре Кипра. Перед оплатой нажми «Есть код на скидку?» и введи мой код :code',

    // Telegram community banner in the profile and the caption under it: one line each
    'community_invite_title': 'Есть вопросы?',
    'community_invite_meta': 'Подскажут в\u00a0нашем чате',
    'community_invite_join': 'Спросить',
    'community_invite_caption': 'Даты экзаменов, регистрация, подготовка',
    'community_invite_hide': 'Скрыть',

    // Word stats labels
    'stat_accuracy': ':value% точн.',
    'stat_correct_attempts': ':correct из :total прав.',
    'stat_learned_at': 'выучено :time',
    'stat_last_practice': 'послед. :time',

    // AI Tutor
    'ai_tutor': 'AI Репетитор',
    'tutor_subtitle': 'Ваш личный помощник по греческому языку',
    'new_chat': 'Новый чат',
    'new_chat_description': 'Начните новый разговор с AI репетитором',
    'voice_chat': 'Голосовой чат',
    'voice_chat_desc': 'Говорите и слушайте на греческом',
    'exercises': 'Упражнения',
    'exercises_desc': 'Интерактивные карточки',
    'recent_chats': 'Недавние чаты',
    'no_chats_yet': 'Пока нет диалогов',
    'start_learning': 'Начните свой первый урок с AI репетитором!',
    'type_message': 'Введите сообщение...',
    'listening': 'Слушаю...',

    // AI Tutor - Topics & Quiz
    'quick_quiz': 'Быстрый тест',
    'quick_quiz_desc': 'Проверьте знания за 10 вопросов',
    'start_quiz': 'Начать тест',
    'quiz_focus_prompt': 'Что вы хотите практиковать?',
    'ai_decide': 'ИИ выберет',
    'ai_decide_desc': 'На основе ваших слабых мест и прогресса',
    'specific_topic': 'Выбрать тему',
    'specific_topic_desc': 'Выберите область для практики',
    'select_skill_area': 'Выберите область',
    'tap_to_start': 'Нажмите, чтобы начать',
    'not_practiced': 'Новое',
    'error_loading_skills': 'Не удалось загрузить навыки',
    'skill_area_grammar': 'Грамматика',
    'skill_area_grammar_desc': 'Артикли, глаголы, падежи и другое',
    'skill_area_vocabulary': 'Словарный запас',
    'skill_area_vocabulary_desc': 'Слова, фразы и выражения',
    'skill_area_communication': 'Коммуникация',
    'skill_area_communication_desc': 'Практические разговоры',
    'generating_quiz': 'Генерация теста...',
    'ai_preparing_questions': 'ИИ готовит вопросы для вас',
    'speaking_topics': 'Темы для разговора',
    'dialogue_history': 'История',
    'no_dialogues_yet': 'Пока нет сессий',
    'start_first_dialogue': 'Начните свой первый разговор или тест!',
    'load_more': 'Загрузить ещё',
    'error_loading_topics': 'Не удалось загрузить темы',
    'no_topics_available': 'Темы пока недоступны',

    // AI Tutor - Topic Selection
    'select_level': 'Выберите уровень сложности',
    'error_loading_topic': 'Не удалось загрузить тему',
    'choose_scenario': 'Выберите сценарий',
    'your_progress': 'Ваш прогресс',

    // AI Tutor - Dialogue
    'speaking_practice': 'Разговорная практика',
    'type_in_greek': 'Пишите на греческом...',
    'end_conversation': 'Завершить',
    'abandon_dialogue': 'Выйти без сохранения',
    'back_to_topics': 'К темам',
    'dialogue_completed': 'Этот разговор завершён',
    'error_loading_dialogue': 'Не удалось загрузить диалог',
    'starting_dialogue': 'Начинаем...',
    'scenario': 'Сценарий',
    'finish_dialogue': 'Завершить диалог',
    'finish_and_review': 'Завершить',
    'preparing_review': 'Готовим ваш отзыв...',

    // AI Tutor - Quiz
    'starting_quiz': 'Начинаем...',
    'error_loading_quiz': 'Не удалось загрузить тест',
    'exit_quiz_title': 'Выйти из теста?',
    'exit_quiz_message': 'Ваш прогресс не будет сохранён.',
    'leave': 'Выйти',
    'type_answer': 'Введите ответ...',
    'quiz_completed': 'Тест завершён!',

    // AI Tutor - Scores & Feedback
    'grammar_score': 'Грамматика',
    'vocabulary_score': 'Словарный запас',
    'communication_score': 'Коммуникация',
    'strengths': 'Сильные стороны',
    'areas_to_improve': 'Над чем работать',
    'overall_feedback': 'Общий отзыв',
    'practice_again': 'Практиковаться снова',
    'try_another_quiz': 'Пройти другой тест',

    // Correction Phase (DuoLingo-style)
    'correction_phase_title': 'Исправим ошибки!',
    'correction_phase_subtitle': 'Повторите упражнения, в которых были ошибки.',
    'exercise_to_correct': 'упражнение для исправления',
    'exercises_to_correct': 'упражнений для исправления',
    'lets_go': 'Поехали!',
    'correction_phase_label': 'Работа над ошибками',

    // AI Tutor - Exercise & Quiz Cards
    'type_your_answer': 'Введите ответ...',
    'type_translation': 'Введите перевод...',
    'fill_in_blank': 'Заполните пропуск...',
    'submit': 'Отправить',
    'excellent_correct': 'Отлично! Это правильный ответ!',
    'keep_practicing_next_time': 'Продолжайте практиковаться! В следующий раз получится.',
    'not_quite': 'Не совсем',
    'explanation': 'Объяснение',

    // AI Tutor - Quiz Summary
    'quiz_complete': 'Тест завершён!',
    'wrong': 'неверно',
    'questions_label': 'Вопросов',
    'time_label': 'Время',
    'areas_tested': 'Проверенные темы',
    'focus_on': 'Обратите внимание',
    'quiz_cost': 'Стоимость теста',

    // AI Tutor - Feedback Summary
    'conversation_complete': 'Разговор завершён!',
    'exchanges_in_session': 'реплик в этой сессии',
    'your_scores': 'Ваши оценки',
    'average': 'в среднем',
    'session_cost': 'Стоимость сессии',

    // AI Tutor - Topic Card & Message Bubble
    'never_practiced': 'Ещё не практиковались',
    'just_now': 'Только что',
    'minutes_ago': ':count мин назад',
    'hours_ago': ':count ч назад',
    'days_ago': ':count дней назад',
    'weeks_ago': ':count недель назад',
    'months_ago': ':count месяцев назад',
    'avg_score': 'Средний',
    'start_session': 'Начать',
    'stop': 'Стоп',
    'listen': 'Слушать',
    'room_to_grow': 'Есть куда расти!',
    'good_work': 'Хорошая работа!',

    // GreekBrain Practice
    'practice_title': 'Практика',
    'practice_subtitle': 'Развивайте греческий шаг за шагом',
    'practice_ready_continue': 'Готовы продолжить?',
    'practice_pick_up': 'Продолжите с того места, где остановились',
    'practice_resume_learning': 'Продолжить обучение',
    'practice_failed_load': 'Не удалось загрузить главы',
    'practice_retry': 'Повторить',
    'practice_no_chapters': 'Нет доступных глав',
    'practice_check_back': 'Скоро появится новый контент',
    'practice_skill_done': 'Готово',
    'skill_vocabulary': 'Словарный запас',
    'skill_grammar': 'Грамматика',
    'skill_communication': 'Общение',

    // Community Group
    'join_community': 'Присоединиться',
    'join_community_cta': 'Вступите в нашу Telegram-группу',

    // Study Progress Widget
    'empty_readiness_message': 'Ответьте на первые вопросы — здесь появится ваш прогноз на экзамен.',
    // Баннер мобильного приложения (App Store / Google Play)
    'ios_app_banner_title': 'Скачайте Халуминати для iPhone',
    'ios_app_banner_subtitle': 'Напоминания о тренировках и запуск с домашнего экрана.',
    'ios_app_banner_cta': 'Загрузить в App Store',
    'android_app_banner_title': 'Скачайте Халуминати для Android',
    'android_app_banner_subtitle': 'Напоминания о тренировках и запуск с домашнего экрана.',
    'android_app_banner_cta': 'Скачать в Google Play',
    'app_banner_cta_short_ios': 'В App Store',
    'app_banner_cta_short_android': 'В Google Play',
    'desktop_app_banner_label': 'Также доступно на iPhone и Android',

    // Онбординг (Android — портирован с нативного iOS-онбординга)
    'onboarding_next': 'Далее',
    'onboarding_start': 'Начать подготовку',
    'onboarding_login': 'Войти',
    'onboarding_hook_headline': 'Всё для сдачи экзамена по культуре Кипра',
    'onboarding_hook_subtitle': 'Вопросы, словарь, гид — в одном приложении. Без разрозненных PDF и устаревших материалов.',
    'onboarding_hook_badge_learners': 'готовятся с нами',
    'onboarding_hook_badge_pass': 'сдают с первого раза',
    'onboarding_hook_badge_questions': 'вопросов по экзамену',
    'onboarding_practice_headline': '1 200+ вопросов по реальным экзаменам',
    'onboarding_practice_subtitle': 'Тренируйтесь на своём языке, потом переключайтесь на греческий. Приложение покажет ваши слабые темы.',
    'onboarding_vocab_headline': '2 400+ слов из экзаменационных вопросов — сначала самые частые',
    'onboarding_vocab_subtitle': 'Умное повторение — приложение само решает, какое слово повторить и когда.',
    'onboarding_guide_headline': 'Гид по Кипру — 40+ глав от неолита до правительства',
    'onboarding_guide_subtitle': 'Вся информация, которая встречается на экзамене — собрана, структурирована и регулярно обновляется.',
    'onboarding_guide_tag_history': 'История',
    'onboarding_guide_tag_politics': 'Политика',
    'onboarding_guide_tag_culture': 'Культура',
    'onboarding_guide_tag_geography': 'География',
    'onboarding_guide_tag_economy': 'Экономика',

    // ── Мастер настройки ───────────────────────────────────────────────────
    // Переписано 21.08.2026 по docs/design/voice-and-tone.md §8 и §9 (строка 2).
    // Русский здесь — не перевод английского: §8.6 отдельно отмечает, что
    // русские вопросы изначально были короче и естественнее английских (глагол
    // никуда не девается), поэтому «удлинять» их не нужно. Что менялось:
    // подзаголовку Q1 вернули объяснение, зачем мы спрашиваем; варианты ответа
    // стали самодостаточными — читаются без вопроса над ними; «сессия» →
    // «тренировка»; ё везде; ваш — строчными; без канцелярита и без эмодзи-
    // усилителей.
    'setup_yes': 'Да',
    'setup_step_of': 'Шаг :current из :total',
    'setup_back': 'Назад',
    'setup_wizard_skip': 'Пропустить',
    'setup_saved': 'Отметили, спасибо.',

    // Шаг 0 — чьё это приложение, о каком экзамене речь и на что уйдёт минута.
    'setup_welcome_title': 'Всё для сдачи экзамена по культуре Кипра',
    'setup_welcome_body': 'Без разрозненных PDF и устаревших материалов — всё в одном месте.',
    'setup_welcome_cta': 'Начать',
    'setup_welcome_skip': 'Не сейчас',

    // Goal — зачем человек пришёл; ответ определяет остальные шаги.
    'setup_goal_title': 'Что вас сюда привело?',
    'setup_goal_body': 'От этого зависит, какие даты и напоминания настроим.',
    'setup_goal_exam': 'Мне нужно сдать экзамен по культуре',
    'setup_goal_curious': 'Просто интересно про Кипр — без экзамена',

    // Шаг 1 — язык
    'setup_lang_title': 'На каком языке показывать приложение?',
    'setup_lang_body': 'От этого зависят вопросы, гид и все напоминания.',

    // Шаг 2 — экзамен по культуре: та самая дата, к которой всё и считается.
    'setup_culture_title': 'Когда сдаёте экзамен по культуре?',
    'setup_culture_body': 'Посчитаем дни до вашей даты и напомним про регистрацию.',
    'setup_culture_passed': 'Экзамен уже сдан',
    'setup_culture_undecided': 'Дата пока не выбрана',
    // Только когда экран стоит отдельно (Профиль, вопрос при запуске) — см. CULTURE_NOT_SITTING.
    'setup_culture_not_sitting': 'Не буду сдавать экзамен',
    'setup_culture_signup_opens': 'Регистрация с :date',
    'setup_culture_signup_until': 'Регистрация до :date',
    'setup_culture_signup_closed': 'Регистрация закрыта',

    // Шаг 3 — напоминания
    'setup_reminders_title': 'Как часто напоминать о тренировках?',
    'setup_reminders_body': 'Напомним позаниматься и ещё раз — перед экзаменом. Поменять можно в любой момент.',
    'setup_reminders_daily': 'Каждый день',
    'setup_reminders_weekly': 'Раз в неделю',
    'setup_reminders_never': 'Не напоминать',

    // Шаг 4 — греческий. Объяснение стоит только под Q1: дальше человек уже
    // согласился отвечать, и причина на каждом экране читается как уговоры.
    'setup_q1_title': 'Греческий тоже сдаёте?',
    'setup_q1_sub': 'Покажем ближайшие даты и когда откроется регистрация.',
    'setup_q1_passed': 'Сертификат уже есть',
    'setup_q1_not_yet': 'Ещё предстоит',
    'setup_q1_not_needed': 'Сертификат не нужен',

    'setup_q2_title': 'Какой уровень греческого вам нужен?',
    'setup_q2_caption': 'Зависит от вашей категории и от того, сколько вы на Кипре, — точный уровень подскажет юрист.',
    'setup_q2_other': 'Другой',
    'setup_q2_unknown': 'Пока не знаю',

    'setup_q2b_title': 'Какой у вас уровень греческого?',
    'setup_q2b_b2plus': 'B2 или выше',
    'setup_q2c_title': 'Нужен ли уровень греческого выше?',
    'setup_q2c_no': 'Нет, больше не нужно',

    'setup_q3_title': 'Учите греческий сейчас?',
    'setup_q3_teacher': 'Да, с преподавателем',
    'setup_q3_self': 'Да, самостоятельно',
    'setup_q3_soon': 'Пока нет, собираюсь',
    'setup_q3_no': 'Нет',

    'setup_q4_title': 'Когда сдаёте греческий?',
    'setup_q4_sub': 'Выберите дату — напомним, пока регистрация ещё открыта.',
    'setup_q4_later': 'Позже',
    'setup_q4_unknown': 'Пока не знаю',

    // ── Финальный экран: их экзамен, один вход и как готовиться ───────────
    'setup_done_title': 'Всё готово',
    'setup_done_sub_curious': 'Без экзамена — просто Кипр, в своём темпе.',
    'setup_done_sub_not_needed': 'Греческий не нужен — больше не спросим.',
    'setup_done_sub_passed': 'Сертификат по греческому есть — вернёмся к этому, только если понадобится уровень выше.',
    'setup_done_sub_culture_passed': 'Сдавать больше нечего. Впереди может быть только греческий.',
    'setup_done_cta': 'Открыть Халуминати',

    'setup_exam_card_name': 'Экзамен по истории и культуре Кипра',
    'setup_exam_card_facts': '25 вопросов · проходной балл 60%',
    'setup_exam_card_signup': 'Регистрация открывается :date — напомним',
    'setup_exam_days_one': ':count день до экзамена',
    'setup_exam_days_few': ':count дня до экзамена',
    'setup_exam_days_many': ':count дней до экзамена',
    'setup_greek_watch': 'Греческий: :value — напомним, когда откроется регистрация.',
    'setup_greek_remind': 'Греческий: :value — напомним перед экзаменом.',

    'setup_start_title': 'Начните с 10 вопросов',
    'setup_start_body': 'Первая тренировка ждёт на главной — три минуты, и станет видно, какие темы стоит подтянуть.',
    'setup_start_body_curious': 'Первая тренировка ждёт на главной — 10 вопросов о Кипре, три минуты.',
    'setup_test_foot': '82% тех, кто готовится с Халуминати, сдают с первого раза.',

    'setup_plan_title': 'Как эффективно подготовиться',
    'setup_plan_1_title': 'Тренируйтесь по 10 минут в день',
    'setup_plan_1_desc': 'Халуминати подберёт вопросы по вашим слабым темам.',
    'setup_plan_2_title': 'Начинайте на русском, переходите на греческий',
    'setup_plan_2_desc': 'Экзамен будет на греческом, и выученным вопрос считается только по ответу на нём.',
    'setup_plan_3_title': '500 экзаменационных слов',
    'setup_plan_3_desc': 'Формулировки в последних билетах усложнили — даже B1 не всегда хватает, чтобы понять вопрос.',
    'setup_plan_4_title': 'Слабые темы дочитывайте в гиде',
    'setup_plan_4_desc': '40+ глав: история, политика, культура, карта и официальные лица.',
    'setup_plan_5_title': 'За неделю — экзамен на время',
    'setup_plan_5_desc': '25 вопросов, условия как на настоящем.',

    'setup_plan_title_curious': 'Что есть в Халуминати',
    'setup_curious_1_title': '1 200+ вопросов из реальных билетов',
    'setup_curious_1_desc': 'Короткие тренировки по 10 минут, темы Халуминати подбирает сам.',
    'setup_curious_2_title': 'Гид по Кипру',
    'setup_curious_2_desc': '40+ глав: история, политика, культура, карта и официальные лица.',
    'setup_curious_3_title': '2 400+ слов из экзаменационных вопросов',
    'setup_curious_3_desc': 'Те же слова, что в экзаменационных билетах, — с переводом.',

    // ── Постоянные пользователи: подтвердить ответ и рассказать про результат ──
    'setup_confirm_body': 'Чтобы напоминания и даты оставались актуальными.',
    'setup_confirm_yes': 'Да',
    'setup_confirm_changed': 'Планы изменились',
    'setup_confirm_thanks': 'Спасибо, отметили.',

    // ── Профиль › Ваши экзамены: что указано и как это поменять ──
    'profile_exams': 'Ваши экзамены',
    // Заголовок уже говорит «экзамены», строки его не повторяют.
    'profile_exam_culture': 'Культура',
    'profile_exam_greek': 'Греческий',
    'profile_exam_passed': 'Сдан',
    'profile_exam_not_sitting': 'Не сдаю',
    'profile_exam_not_needed': 'Не нужен',
    'profile_exam_undecided': 'Дата не выбрана',
    'profile_exam_preparing': 'Готовлюсь',
    'profile_exam_add': 'Указать',

    'setup_result_culture_title': 'Как всё прошло?',
    'setup_result_culture_body': 'Расскажете, как сдали? Нам это очень помогает.',
    'setup_result_greek_title': 'А греческий — как прошло?',
    'setup_result_greek_body': 'Последний вопрос, обещаем.',
    'setup_result_passed_60': 'Набрал(а) 60% и больше',
    'setup_result_50_60': 'От 50% до 60%',
    'setup_result_passed': 'Сдал(а)',
    'setup_result_failed': 'Не сдал(а)',
    'setup_result_skipped': 'Я не сдавал(а)',
    'setup_result_congrats': 'Поздравляем! Самое сложное позади.',
    'setup_result_noted': 'Спасибо, записали.',

    // Заголовок того экрана, с которого начинается опрос, — но только когда
    // министерство уже опубликовало результаты. Человек, пришедший по пушу
    // «результаты готовы», должен увидеть результаты, а не голый вопрос о них.
    'setup_result_ready_title': 'Результаты экзамена опубликованы 🇨🇾',
    'setup_result_ready_body': 'Официальные результаты за {month} — по ссылке ниже.',
    // Стоит ПОД ссылкой: сначала то, за чем пришли, потом просьба.
    'setup_result_share_prompt': 'Поделитесь с нами вашими результатами',
    'setup_result_pdf_link': 'Открыть официальные результаты',
    'setup_result_not_sat': 'Я не сдавал(а) в {month}',

    // В каком потоке сдавали? Спрашиваем, только если экзамен шёл в два потока
    // с разными вариантами — как в июле 2026: в 09:00 и в 11:00.
    'setup_result_sitting_title': 'В каком потоке вы сдавали?',
    'setup_result_sitting_at': 'Поток в {time}',

    // Спрашиваем после любого ответа, кроме «сдал». Не дату — следующая дата
    // на этот момент обычно ещё не объявлена.
    'setup_next_exam_title': 'Будете сдавать в следующий раз?',
    'setup_next_exam_yes': 'Да, буду сдавать',
    'setup_next_exam_unsure': 'Пока не решил(а)',
    'setup_next_exam_no': 'Нет, больше не буду',
    'setup_next_exam_thanks': 'Спасибо. Напишем, когда объявят даты.',

    // Только для сдавших и только в мобильном приложении: единственный момент,
    // когда просьба об отзыве не выглядит навязчивой.
    'setup_review_title': 'Поздравляем со сдачей!',
    'setup_review_body': 'Если Халуминати помог — оставьте отзыв. Это пара минут, а новых людей к нам приводят как раз отзывы.',
    'setup_review_cta': 'Оставить отзыв',
    'setup_review_later': 'Не сейчас',

    'setup_replay_title': 'Пройти онбординг заново',
    'setup_replay_desc': 'Пройти весь поток заново, с первого экрана',

    // Подарки — docs/hallouminati/gift-codes.md
    'back': 'Назад',
    'gift_row_title': 'Подарить Халуминати',
    'gift_buy_title': 'Адепт в подарок',
    'gift_buy_cta': 'Купить за :price',
    'gift_sale_until': '−:percent% до :date',
    'gift_quantity_label': 'Количество подарков',
    'gift_purchase_waiting': 'Упаковываем подарки…',
    'gift_purchase_pending': 'Оплата прошла — подарки появятся здесь через минуту.',
    'gift_your_gifts': 'Ваши подарки',
    'gift_opened_on': 'Открыт :date',
    'gift_send': 'Отправить',
    'gift_copy_link': 'Скопировать ссылку',
    'gift_link_copied': 'Ссылка скопирована',
    'gift_share_text': '🎁 Тебе подарок — Халуминати Адепт, полная подготовка к экзамену по истории и культуре Кипра.',
    'gift_for_you': 'Вам подарок',
    'gift_from': 'от :name',
    'gift_account_label': 'Получит',
    'gift_not_you': 'Не вы?',
    'gift_open_cta': 'Открыть подарок',
    'gift_open_failed': 'Не получилось открыть подарок. Попробуйте ещё раз.',
    'gift_already_yours': 'Этот подарок уже ваш',
    'gift_already_opened': 'Этот подарок уже открыли',
    'gift_not_found': 'Подарок не найден',
    'gift_own_title': 'Ваш подарок для друга',
    'gift_already_pro_title': 'Вы уже Адепт',
    'gift_pass_on': 'Передать другу',
    'gift_needs_account': 'Войдите, чтобы открыть подарок',

    // Quiz marks and history: the chip, «О вопросе», «Избранные», the lists
    // (docs/hallouminati/question-bank.md §Marks and history)
    'qs_stage_new': 'Новый',
    'qs_stage_learning': 'Учу',
    'qs_stage_almost': 'Почти выучено',
    'qs_stage_learned': 'Выучено',
    'qs_stage_known': 'Знаю',
    'qs_note_learning': 'Чтобы выучить, ответьте верно на греческом',
    'qs_note_almost': 'Осталось ответить верно на греческом',
    'qs_note_learned': 'Засчитан в прогресс',
    'qs_note_known': 'Вы отметили сами',
    'qs_how_title': 'Как это работает?',
    'qs_how_new': 'Ещё не отвечали',
    'qs_how_learning': 'Пока без верного ответа',
    'qs_how_almost': 'Верно на русском. Осталось на греческом',
    'qs_how_learned': 'Верно на греческом',
    'qs_how_known': 'Вы отметили сами',
    'qs_how_p1': 'В прогресс вопрос идёт после первого верного ответа на греческом.',
    'qs_how_p2': 'Потом он вернётся ещё 4 раза, всё реже, чтобы не забылся. После 5 верных ответов подряд он уходит на 60 дней. На процент повторы не влияют.',
    'qs_how_p3': 'Ошибка остаётся в «Ошибках», пока вы не ответите верно. Выученный вопрос из процента уже не уходит.',
    'qs_how_p4': 'Ответы на русском помогают понять вопрос, но в прогресс не идут: экзамен будет на греческом.',
    'qs_how_p5': 'Процент считает основные вопросы. Сложные и редкие идут отдельно.',
    'qs_how_stages': 'Статусы вопросов',
    'qs_why_title': 'Почему вопрос вернулся?',
    'qs_why_p1': 'Каждый верный ответ на греческом подряд откладывает вопрос дольше: на 1, 3, 7, 21, потом 60 дней. Ошибка возвращает его на завтра, верный ответ на русском вернёт через 3 дня.',
    'qs_why_p2': 'Так лёгкие вопросы уходят сами, а трудные остаются рядом. Вопрос со звёздочкой вернётся не позже чем через 7 дней.',
    'qs_why_p3': 'Знаете вопрос точно? «Отметить выученным» уберёт его сразу.',
    'qs_sheet_title': 'О вопросе',
    'qs_repeats_left_one': 'Ещё :count верный ответ на греческом, и вопрос уйдёт на :days',
    'qs_repeats_left_few': 'Ещё :count верных ответа на греческом подряд, и вопрос уйдёт на :days',
    'qs_repeats_left_many': 'Ещё :count верных ответов на греческом подряд, и вопрос уйдёт на :days',
    'qs_repeats_done': 'Все :count повторов пройдены',
    'qs_back_after_mistake': 'Вернулся после ошибки :date',
    'qs_back_after_other': 'Вернулся через :days после ответа на русском',
    'qs_back_after_right': 'Вернулся через :days после верного ответа',
    'qs_next_tomorrow': 'Вернётся завтра',
    'qs_next_in': 'Следующий повтор через :days',
    'qs_next_due': 'Пора повторить',
    'qs_known_out': 'Больше не покажем в тренировках',
    'qs_right_count': ':count верно',
    'qs_history_all': 'Все :count',
    'qs_history_less': 'Свернуть',
    'qs_paper': 'Был на экзамене, :month',
    'qs_error_rate': ':pct% учеников ошибаются',
    'qs_star_add': 'В избранное',
    'qs_mark_known_short': 'Знаю',
    'qs_star_on': 'В избранном',
    'qs_relearn': 'Учить заново',
    'qs_answer': 'Ответить',
    'qs_back_to_list': 'Назад к списку',
    'qs_toast_starred': 'Добавлено в избранные',
    'qs_toast_unstarred': 'Убрано из избранных',
    'qs_toast_starred_back': 'В избранном. Вернём в тренировки',
    'qs_toast_known': 'Больше не покажем',
    'qs_toast_known_unstar': 'Больше не покажем. Звёздочка снята',
    'qs_toast_relearn': 'Вернули в тренировки',
    'qs_toast_greek': 'Вопросы теперь на греческом',
    'qs_toast_error': 'Не получилось. Попробуйте ещё раз',
    'qs_starred_title': 'Избранные',
    'qs_practise_all': 'Тренировать все :count',
    'qs_see_all': 'Все :count',
    'qs_list_empty': 'Пока пусто',
    'qs_empty_mistakes_title': 'Ошибок нет',
    'qs_empty_mistakes_text': 'Сюда попадает вопрос, на который вы ответили неверно. Ответите верно — он уйдёт.',
    'qs_empty_starred_title': 'Избранных пока нет',
    'qs_empty_starred_text': 'Отметьте вопрос звёздочкой в тренировке, и он появится здесь. Такой вопрос вернётся не позже чем через неделю.',
    'qs_all_questions': 'Все вопросы темы',
    'qs_filter_all': 'Все',
    'qs_filter_learning': 'Учу',
    'qs_filter_almost': 'Почти',
    'qs_filter_new': 'Новые',
    'qs_filter_learned': 'Выучено',
    'qs_search': 'Поиск',
    'qs_nothing_found': 'Ничего не нашлось',
    'qs_more_rows': 'Ещё :count',
    'qs_other_language_line': 'Ответы на русском видим, но не засчитываем',
    'qs_unstar_right': 'Убрать звёздочку у верных: :count',
    'qs_unstarred_done': 'Звёздочки сняты: :count',
    'qs_days_one': ':count день',
    'qs_days_few': ':count дня',
    'qs_days_many': ':count дней',
    'qs_answers_one': ':count ответ',
    'qs_answers_few': ':count ответа',
    'qs_answers_many': ':count ответов',
    'qs_hist_right': 'верно',
    'qs_hist_wrong': 'неверно',
    'qs_card_error': 'Не удалось загрузить вопрос',
    'qs_back': 'Назад',
};
